// src/components/AnswerButtons.js
import React from "react";
import "./style.css";

const AnswerButtons = ({ index, onAnswer, selectedValue }) => {
  const buttonValues = [0, 1, 2, 3];

  return (
    <div className="answer-buttons-container">
      {buttonValues.map((value, buttonIndex) => (
        <div className="button-container" key={buttonIndex}>
          {" "}
          <button
            key={buttonIndex}
            className={`answer-button ${value === selectedValue ? "answer-button-selected" : ""}`}
            onClick={() => onAnswer(index, value)}
          >
            {value}
          </button>
        </div>
      ))}
    </div>
  );
};

export default AnswerButtons;
